import actions from 'modules/tool/view/toolViewActions';
import viewReducers from 'modules/shared/view/viewReducers';
export default viewReducers(actions);
